import {newModalFromString, newModalWithOptions} from '../components/modal';
import productSlider from '../components/productSlider';
import {initSlotCarousel} from '../productTileComponent/productTile';
import { slickArrowPrev, slickArrowNext, mobileSlickArrowPrev, mobileSlickArrowNext } from '../components/slickArrows';

// Helper
var timeoutMinicart = null;
var timeoutFeedbackCart = null;
var crossSellNavActive = false;

function forceHideMinicart () {
    if (timeoutMinicart != null) {
        clearTimeout(timeoutMinicart);
        timeoutMinicart = null;
    }
    if ($('.minicart .popover').hasClass('show')) {
        $('body').trigger('minicart:close');
    }
    $('.minicart .popover').removeClass('show');
    $('.minicart').removeClass('open');
    setTimeout(function () {
        if (!$('.minicart').hasClass('open')) {
            $('.minicart .popover').removeClass('js-minicart-popover');
            $('.black-background').addClass('hide');
        }
    }, 150);
}

function forceShowMinicart () {
    const currentURL = location.protocol + '//' + location.host + location.pathname;
    const targetURL = $('.minicart .minicart-link').attr('href');
    if (targetURL === currentURL) {
        return;
    }
    if (!Foundation.MediaQuery.atLeast('large')) {
        return;
    }
    $('.minicart').addClass('open');

    var url = $('.minicart').data('action-url');

    if ($('.minicart .popover.show').length === 0) {
        $.get(url, function (data) {
            const $minicart = $('.minicart .popover');
            $minicart.empty().append(data);
            $('.js-bonus-product-msg', '.minicart .popover').addClass('hide');

            let hadClass = $minicart.hasClass('show');
            calculateMinicartTop();
            $minicart.addClass('show');
            $minicart.addClass('js-minicart-popover');

            if (!hadClass) {
                $('body').trigger('minicart:open');
            }

            $('.minicart .popover.show').on('mouseenter focusin', (e) => {
                if (timeoutMinicart != null) {
                    clearTimeout(timeoutMinicart);
                    timeoutMinicart = null;
                }
            });

            $('.minicart .popover.show').on('mouseleave', (e) => {
                if (timeoutMinicart != null) {
                    clearTimeout(timeoutMinicart);
                    timeoutMinicart = null;
                }
                timeoutMinicart = setTimeout(forceHideMinicart, 5000);
            });

            if (timeoutMinicart != null) {
                clearTimeout(timeoutMinicart);
                timeoutMinicart = null;
            }
            timeoutMinicart = setTimeout(forceHideMinicart, 5000);
        });
    }
}

function calculateMinicartTop () {
    const $feedbackModal = $('.popover.popover-bottom');
    if ($feedbackModal.length === 0) return;

    let top = 0;

    const $sovraContainer = $('.top-header-placement');
    if ($sovraContainer.is(':visible')) {
        top += $sovraContainer.outerHeight() || 0;
    }

    const $countrySelect = $('.geoblockContainerBlur');
    if ($countrySelect.length && !$countrySelect.hasClass('hidden')) {
        top += $countrySelect.outerHeight() || 0;
    }

    $feedbackModal.css('top', top);
}

const crossSellItems = (pid, promoId, crosssellItemsBase, $feedbackPopover) => {
    if ($('#rightBarMinicart').css('display') === 'none') {
        $('#Look').removeClass('hidden');
    }

    calculateMinicartTop();

    let requestUrl = crosssellItemsBase.val();
    const promotionId = promoId || $('.container .promo-message--tezenis').data('promotion-id');

    $.ajax({
        url: requestUrl,
        data: {
            pid: pid,
            promotionId: promotionId
        },
        method: 'GET',
        success: data => {
            if (data.trim() === '') {
                $('#Look h4').addClass('hidden');
                $('.completeYourLookContainer h6').addClass('hidden');
                return;
            }
            var $minicartCtx = $feedbackPopover || $('.minicart.open .popover.show');
            $minicartCtx.find('[id="crossSellContainerMinicart"]').each(function () {
                this.innerHTML = data;
            });
            $minicartCtx.find('[id="rightBarMinicart"]').show();

            if ($minicartCtx.find('.crosssell-view.js-cross-product').length > 4) {
                $minicartCtx.find('.suggestedProductsContainer--tezenis .show-more').show();
            }

            $minicartCtx.find('.suggestedProductsContainer--tezenis .show-more').on('click', (evt) => {
                evt.preventDefault();
                $minicartCtx.find('.crosssell-view.js-cross-product').removeClass('hide-for-medium');
                $minicartCtx.find('.suggestedProductsContainer--tezenis .show-more').addClass('hide');
                $('body').trigger('product:crossSellLoaded', {loadHead: false, fromMinicart: true});
            });

            var isCompletePromo = false;
            ['promoSlider', 'lookSlider'].forEach(function (id) {
                var $slider = $minicartCtx.find('[id="' + id + '"]');

                if ($slider.length) {
                    if ($slider.hasClass('slick-initialized')) {
                        $slider.slick('destroy');
                    }

                    $slider.slick({
                        slidesToShow: 2.3,
                        slidesToScroll: 1,
                        infinite: false,
                        draggable: true,
                        slide: '.crosssell-view',
                        arrows: false,
                        responsive: [
                            {
                                breakpoint: 641,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                    infinite: false,
                                    draggable: true
                                }
                            }
                        ]
                    });

                    $slider.find('img').on('load', function () {
                        $slider.slick('setPosition');
                    });
                }
            });
            if ($minicartCtx.find('.promoCrossSellEnabled').length) {
                var $carouselContainer = $minicartCtx.find('.suggested-products');
                $carouselContainer.find('.promo-message').hide();
                $carouselContainer.find('.suggested-products-promo-title').removeClass('hidden');
                var promoName = $('.container .promo-message--tezenis:first').text().trim();
                if (promoName.toLowerCase().indexOf('promo') === 0) {
                    promoName = promoName.substring(6);
                }
                $carouselContainer.find('.suggested-products-promo-message').text(promoName);
                isCompletePromo = true;
            }

            $minicartCtx.find('.js-crosssell-nav').each(function () {
                var $nav = $(this);
                var targetSelector = $nav.data('target');
                var $parentPopover = $nav.closest('.popover');
                var $target = $parentPopover.find('[id="' + targetSelector.substring(1) + '"]');
                $nav.find('.js-crosssell-prev').on('mousedown click touchstart', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    crossSellNavActive = true;
                    setTimeout(function () { crossSellNavActive = false; }, 300);
                    if (timeoutFeedbackCart) { clearTimeout(timeoutFeedbackCart); }
                    timeoutFeedbackCart = setTimeout(function () { forceHideFeedbackCart(); }, 5000);
                    if (!$(this).data('sliding')) {
                        $(this).data('sliding', true);
                        var btn = $(this);
                        if ($target.length && $target.hasClass('slick-initialized')) {
                            $target.slick('slickPrev');
                        }
                        setTimeout(function () { btn.data('sliding', false); }, 300);
                    }
                });
                $nav.find('.js-crosssell-next').on('mousedown click touchstart', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    crossSellNavActive = true;
                    setTimeout(function () { crossSellNavActive = false; }, 300);
                    if (timeoutFeedbackCart) { clearTimeout(timeoutFeedbackCart); }
                    timeoutFeedbackCart = setTimeout(function () { forceHideFeedbackCart(); }, 5000);
                    if (!$(this).data('sliding')) {
                        $(this).data('sliding', true);
                        var btn = $(this);
                        if ($target.length && $target.hasClass('slick-initialized')) {
                            $target.slick('slickNext');
                        }
                        setTimeout(function () { btn.data('sliding', false); }, 300);
                    }
                });
            });

            $minicartCtx.find('.js-quick-add').on('click', function () {
                forceHideFeedbackCart();
            });

            $('body').trigger('product:crossSellLoaded', {loadHead: true, fromMinicart: true, isCompletePromo: isCompletePromo});
        },
        error: () => {
            $.spinner().stop();
            $('body').trigger('product:crossSellError');
        }
    });
};

function forceShowFeedbackCart (timeout = null, showBonusProductInfo = false, pid, promoId, isBonusProductAdd) {
    forceHideFeedbackCart();
    const currentURL = location.protocol + '//' + location.host + location.pathname;
    const targetURL = $('.minicart .minicart-link').attr('href');
    if (targetURL === currentURL) {
        return;
    }

    let container = $('.minicart.pdp');
    if (container.length === 0 || Foundation.MediaQuery.atLeast('medium')) {
        if (Foundation.MediaQuery.atLeast('medium')) {
            container = $('.minicart:visible').first();
            if (!container.length) {
                container = $('.minicart').first();
            }
        } else {
            container = $('.minicart');
        }
    }

    container.addClass('open');
    var promotionId = promoId ? '&promotionId=' + encodeURIComponent(promoId) : '';
    var url = $('.minicart .minicart-link').data('showMiniCartUrl') + '?pid=' + encodeURIComponent(pid) + promotionId;
    if (isBonusProductAdd) {
        url = url + '&isBonusProductAdd=true';
    }
    if (container.find('.popover.show').length === 0) {
        if (!Foundation.MediaQuery.atLeast('large')) {
            $('body').addClass('feedback-modal-open');
        }
        $.get(url, function (data) {
            container.find('.popover').empty().append(data);
            if (!showBonusProductInfo) {
                $('.js-bonus-product-msg', '.minicart .popover').addClass('hide');
            } else {
                $('.js-bonus-product', '.minicart .popover').addClass('hide');
            }

            let hadClass = $('.minicart .popover').hasClass('show');
            $('.popover').removeClass('cc-minicartPromoModal').addClass('js-feedback-cart-popover');
            container.find('.popover').addClass('show');
            $('.black-background').removeClass('hide');
            if (!hadClass) {
                $('body').trigger('minicart:open');
                $('.layer-complete-your-promo-modal').addClass('hidden');
            }

            $(document).off('.feedbackCart').on('click.feedbackCart touchstart.feedbackCart', function (e) {
                if (crossSellNavActive) {
                    return;
                }
                var targetContainer = container.find('.popover');
                if (!targetContainer.is(e.target) && targetContainer.has(e.target).length === 0) {
                    forceHideFeedbackCart();
                }
            });
            $('.js-feedback-close-button').on('click', function (e) {
                e.preventDefault();
                forceHideFeedbackCart();
            });
            let startTimer = true;
            $('.minicart .popover.show').on('mouseenter focusin', (e) => {
                if (timeoutFeedbackCart != null) {
                    clearTimeout(timeoutFeedbackCart);
                    timeoutFeedbackCart = null;
                }
            });
            $('.minicart .popover.show').on('click', '.js_paypal_button', (e) => {
                startTimer = false;
                if (timeoutFeedbackCart != null) {
                    clearTimeout(timeoutFeedbackCart);
                    timeoutFeedbackCart = null;
                }
            });
            $('.minicart .popover.show').on('mouseleave', (e) => {
                if (!startTimer) {
                    return;
                }

                if (timeoutFeedbackCart != null) {
                    clearTimeout(timeoutFeedbackCart);
                    timeoutFeedbackCart = null;
                }
                timeoutFeedbackCart = setTimeout(() => {
                    forceHideFeedbackCart();
                }, 5000);
            });

            if (timeoutFeedbackCart != null) {
                clearTimeout(timeoutFeedbackCart);
                timeoutFeedbackCart = null;
            }
            timeoutFeedbackCart = setTimeout(() => {
                forceHideFeedbackCart();
            }, 5000);

            var crosssellItemsBase = container.find('#crossSellItemsBaseUrl');
            if (crosssellItemsBase.length) {
                crossSellItems(pid, promoId, crosssellItemsBase, container.find('.popover'));
            }
        });
    }
}

function forceHideFeedbackCart () {
    let isCrosssellOpen = $('.layer-complete-your-promo-modal').hasClass('hidden');
    if (isCrosssellOpen) {
        $('.layer-complete-your-promo-modal').removeClass('hidden');
    }
    if (timeoutFeedbackCart != null) {
        clearTimeout(timeoutFeedbackCart);
        timeoutFeedbackCart = null;
    }
    $('.minicart .popover').removeClass('js-feedback-cart-popover');
    $('.minicart .popover').removeClass('show');
    $('.black-background').addClass('hide');
    $('.minicart').removeClass('open');
    $('body').trigger('feedbackCart:closed');

    if (!Foundation.MediaQuery.atLeast('large')) {
        $('body').removeClass('feedback-modal-open');
    }
}

const crossSellSlider = () => {
    if ($('#crossSellContainerMinicart .js-cross-product').length) {
        if ($('#crossSellContainerMinicart').hasClass('slick-initialized')) {
            $('#crossSellContainerMinicart').slick('unslick');
        }
        $('#crossSellContainerMinicart').slick({
            slide: '.js-cross-product',
            dots: false,
            infinite: false,
            draggable: false,
            speed: 500,
            slidesToShow: 2.1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('.minicart .prev-button-crosssell'),
            nextArrow: $('.minicart .next-button-crosssell'),
            responsive: [{
                breakpoint: 480,
                settings: {
                    slidesToShow: 2.1,
                    slidesToScroll: 1,
                    infinite: false,
                    draggable: true
                }
            }]
        });
    }
};

class Minicart {
    run () {
        // Cart.run();
        this.triggers();
        this.close();
        this.applicablePromotion();
    }

    triggers () {
        $('body').on('count:update', function (event, count) {
            if (count && $.isNumeric(count.quantityTotal)) {
                if (count.quantityTotal > 0) {
                    $('.minicart .minicart-link').addClass('full');
                    let product;
                    if (count.form && count.form.pid) {
                        product = count.form.pid;
                    } else {
                        const cart = count.cart;
                        const items = cart.items;
                        for (var i = 0; i < items.length; i++) {
                            if (items[i].UUID === count.pliUUID) {
                                product = items[i].id;
                                break;
                            }
                        }
                    }
                    let promoId;
                    if (count.form && count.form.promoId) {
                        promoId = count.form.promoId;
                    } else if (count.promoId) {
                        promoId = count.promoId;
                    } else {
                        const cart = count.cart;
                        const items = cart.items;
                        for (var i = 0; i < items.length; i++) {
                            if (items[i].UUID === count.pliUUID) {
                                product = items[i].id;
                                break;
                            }
                        }
                    }
                    let addBonusProductToCart = (count.action && count.action === 'Cart-AddBonusProducts' && count.bonusProduct) ? count.bonusProduct.id : null;
                    if (product) {
                        if (addBonusProductToCart) {
                            forceShowFeedbackCart(true, true, addBonusProductToCart, promoId, true);
                        } else {
                            forceShowFeedbackCart(true, count.newBonusDiscountLineItem && count.newBonusDiscountLineItem.newBonusDiscountLineItemAutomaticallyAdded, product, promoId, false);
                        }
                        if ($('.js-feedback-cart-popover #crossSellVariation').children().length > 0 && $('.page').data('action') !== 'Cart-Show') {
                            let id = Foundation.MediaQuery.atLeast('medium') ? 'rightBarMinicart' : 'Look';
                            let yOffset = id === 'Look' ? -20 : document.querySelector('header').getBoundingClientRect().height;
                            if (id === 'Look' && document.querySelector('header').getBoundingClientRect().height > 0) {
                                yOffset -= (document.querySelector('header').getBoundingClientRect().height - 20);
                            }
                            let element = document.getElementById(id);
                            let y = element.getBoundingClientRect().top + window.pageYOffset - yOffset;
                            window.scrollTo({top: y, behavior: 'smooth'});
                        }
                        $('.minicart').on('focusout', function (event) {
                            if ($(event.target).parents('.feedback-cart').length === 0) {
                                event.stopPropagation();
                                return;
                            }
                            forceHideFeedbackCart();
                        });
                    }
                } else {
                    $('.minicart .minicart-link').removeClass('full');
                }
                $('.minicart .minicart-quantity').removeClass('hidden');
                $('.minicart .minicart-quantity').text(count.cart.numItems);
                if ($('.layer-complete-your-promo-modal').length && ($('.page').data('action') === 'Product-Show')) {
                    $('.layer-complete-your-promo-modal').addClass('hidden');
                }
            }
        });
        $('body').on('count:updateCompletePromo', function (event, count) {
            if (count && $.isNumeric(count.quantityTotal)) {
                if (count.quantityTotal > 0) {
                    $('.minicart .minicart-link').addClass('full');
                } else {
                    $('.minicart .minicart-link').removeClass('full');
                }
                $('.minicart .minicart-quantity').removeClass('hidden');
                $('.minicart .minicart-quantity').text(count.cart.numItems);
            }
        });
    }

    close () {
        $('.minicart').on('mouseleave focusout', function (event) {
            if ((event.type === 'focusout' && $('.minicart').has(event.target).length > 0) ||
                (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity')) ||
                $('body').hasClass('modal-open') ||
                $(event.target).parents('.feedback-cart').length !== 0) {
                event.stopPropagation();
                return;
            }
            forceHideMinicart();
        });
        $('body').on('click', '.minicart-close', e => {
            forceHideMinicart();
        });
    }
    applicablePromotion () {
        $('body').on('click', '.js-cart-applicable-promotion', (e) => {
            e.preventDefault();
            let requestUrl = $(e.currentTarget).find('#complete-your-promo').data('url');
            const pid = $(e.currentTarget).find('.item-complete-your-promo').data('pid');
            const promotionId = $(e.currentTarget).find('#complete-your-promo').data('promotion-id');
            const poductsAdded = $(e.currentTarget).find('#complete-your-promo').data('poducts-added') || '';
            const triggeringAmount = $(e.currentTarget).find('#complete-your-promo').data('triggering-amount') || '';
            const promotionLabel = $(e.currentTarget).find('#complete-your-promo').data('promotion-label') || '';
            const promoPrice = $(e.currentTarget).find('#complete-your-promo').data('promo-price');
            const promoPriceItemsTotal = $(e.currentTarget).find('#complete-your-promo').data('promo-price-items-total');
            const showResidualToTrigger = $(e.currentTarget).find('#complete-your-promo').data('is-residual');

            $.spinner().start();
            $.ajax({
                url: requestUrl,
                data: {
                    pid: pid,
                    promotionId: promotionId,
                    cartApplicablePromo: true,
                    poductsAdded: poductsAdded,
                    triggeringAmount: triggeringAmount,
                    promotionLabel: promotionLabel,
                    promoPrice: promoPrice,
                    promoPriceItemsTotal: promoPriceItemsTotal,
                    showResidualToTrigger: showResidualToTrigger
                },
                method: 'GET',
                success: (data) => {
                    e.preventDefault();
                    var modalContent = data;
                    if (data.trim() === '') {
                        return;
                    }
                    var htmlContent = $('.cart-complete-promotion').html();
                    var modal = newModalFromString(
                        htmlContent,
                        false,
                        ['layer-complete-your-promo-modal', 'cc-low-z-index', 'js-complete-your-promo-modal'],
                        null,
                        () => {
                            modal.destroy();
                            if ($('.page').data('action') !== 'Product-Show') {
                                $.spinner().start();
                                location.reload();
                            }
                        }
                    );

                    $(modal.modalBox).addClass(
                        'new-footer-form-style rightModalAttribute rightModalAttribute_sizeLarge container-complete-your-promo-modal js-complete-your-promo'
                    );
                    modal.setContent(modalContent);
                    modal.open();
                    $.spinner().stop();

                    $(modal.modalBox)
                        .find('.js-close-button, .js-back-button')
                        .on('click', function (e) {
                            modal.close();
                        });

                    initSlotCarousel('.js-complete-your-promo');

                    if (document.querySelectorAll('.crosssell-view.js-cross-product').length > 4) {
                        $('.container-complete-your-promo-modal .show-more').removeClass('hidden');
                    }

                    $('.container-complete-your-promo-modal .show-more').on('click', (evt) => {
                        evt.preventDefault();
                        $('.crosssell-view.js-cross-product').removeClass('hide-for-medium');
                        $('.container-complete-your-promo-modal .show-more').addClass('hide');
                        $('body').trigger('product:crossSellLoaded', {loadHead: false, fromMinicart: true});
                    });

                    $('body').trigger('product:crossSellLoaded', {loadHead: true, fromMinicart: true});
                },
                error: () => {
                    $.spinner().stop();
                },
            });
        });

        $('body').on('click', '.js-add-promotion-item, .js-add-promotion-item-icon', e => {
            e.stopPropagation();
            e.preventDefault();
            $.spinner().start();
            // modal options
            var modalOptions = {
                footer: false,
                closeMethods: ['overlay', 'button', 'escape'],
                closeLabel: '<svg version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"> <path d="M12,11.3L22.3,1L23,1.7L12.7,12L23,22.3L22.3,23L12,12.7L1.7,23L1,22.3L11.3,12L1,1.7L1.7,1C1.7,1,12,11.3,12,11.3z"/></svg>',
                cssClass: ['quickViewPromo-modal', 'js-complete-your-promo-quick-view', 'cc-more-visibility-modal', 'cc-completePromotionModal'],
                onClose: () => {
                    if ($('.js-complete-your-promo-quick-view').length === 0) {
                        $('.carousel-inner, .slick-initialized:not(.suggested-products-slider)').slick('unslick');
                        modal.destroy();
                    }
                },
                beforeClose: () => {
                    if ($('.js-complete-your-promo-quick-view').length === 0) {
                        if ($('.tingle-modal.tingle-modal--visible').length < 2) {
                            $('html').removeClass('html-tingle-enabled');
                        }
                        return true;
                    }
                }
            };
            const modal = newModalWithOptions(modalOptions);
            this.currentlyOpenedModal = modal;

            $.ajax({
                url: $(e.currentTarget).attr('href') || $(e.currentTarget).data('url'),
                method: 'GET',
                dataType: 'json',
                success: rsp => {
                    modal.setContent(rsp.renderedTemplate);
                    // Move close button inside modal content box
                    $('.quickViewPromo-modal').addClass('quickViewPromo-modal--tezenis');
                    $(modal.modalBox).addClass('rightModalAttribute pdp-info-tingle-modal');
                    modal.open();
                    $('html').addClass('html-tingle-enabled');
                    // Slick carousel
                    $('.carousel-inner').slick({
                        dots: false,
                        arrows: true,
                        prevArrow: slickArrowPrev,
                        nextArrow: slickArrowNext,
                        slidesToShow: 3.4,
                        draggable: true,
                        infinite: false,
                        slidesToScroll: 3.4,
                        responsive: [
                            {
                                breakpoint: 769,
                                settings: {
                                    draggable: true,
                                    slidesToShow: 2.85,
                                    slidesToScroll: 2.85,
                                    prevArrow: mobileSlickArrowPrev,
                                    nextArrow: mobileSlickArrowNext,
                                }
                            }
                        ]
                    });
                    productSlider();
                    $.spinner().stop();
                    $(modal.modalBox).on('click', '.close-custom', function () {
                        modal.close();
                        modal.destroy();
                    });
                    $('.js-complete-your-promo-quick-view').on('mousedown', e => {
                        if ($(e.target).closest('.tingle-modal-box').length === 0) {
                            modal.close();
                            modal.destroy();
                        }
                    });
                    $(modal.modalBox).on('click', '.js-close-select-size', function () {
                        let modal = $('.js-modal-quick-size-quantity');
                        modal.addClass('hidden').removeClass('open');
                    });
                    $(modal.modalBox).on('change', '.sizes-container input[type="radio"]', function (e) {
                        $(modal.modalBox).find('.js-completePromotionModal-footer_confirm').removeClass('disabled');
                        let isLastProduct = $(e.currentTarget).data('last-allocation');
                        if (isLastProduct) {
                            $(modal.modalBox).find('.js-productErrorText-single').removeClass('hidden');
                        } else {
                            $(modal.modalBox).find('.js-productErrorText-single').addClass('hidden');
                        }
                    });
                    $(modal.modalBox).on('click', '.product-image', function (e) {
                        e.preventDefault();
                    });
                    $('body').off('updateQuickAddToCartModal');
                    $('body').on('updateQuickAddToCartModal', function (data, form) {
                        let $productItem = $('.layer-complete-your-promo-modal').find('div.product[data-pid="' + $(modal.modalBox).find('.add-to-cart-global').data('pid') + '"]').closest('.js-cross-product').first();
                        let $productItemHidden = $('.suggestedProductsContainer.hide-for-small-only .js-pdp-cross-sell-modal.hidden').find('.product[data-pid="' + $(modal.modalBox).find('.add-to-cart-global').data('pid') + '"]');
                        let quantity = parseInt(form.quantity);
                        const productsLeft = $('.layer-complete-your-promo-modal').find('.js-complete-the-promo-status').val();

                        // Update promotion's tracker
                        for (let i = 0; i < quantity; i++) {
                            $('.js-completeYourPromo-header_tracker_item_active').next('.js-completeYourPromo-header_tracker_item').addClass('js-completeYourPromo-header_tracker_item_active cc-completeYourPromo-header_tracker_item_active');
                        }
                        if (parseInt(productsLeft) <= 0) {
                            $('.layer-complete-your-promo-modal').find('.js-completeYourPromo-header_remaining_completed').removeClass('hidden');
                            $('.layer-complete-your-promo-modal').find('.js-completeYourPromo-header_remaining_single').addClass('hidden');
                            $('.layer-complete-your-promo-modal').find('.js-completeYourPromo-header_remaining_plural').addClass('hidden');
                        } else if (parseInt(productsLeft) === 1) {
                            $('.layer-complete-your-promo-modal').find('.js-completeYourPromo-header_remaining_completed').addClass('hidden');
                            $('.layer-complete-your-promo-modal').find('.js-completeYourPromo-header_remaining_single').removeClass('hidden');
                            $('.layer-complete-your-promo-modal').find('.js-completeYourPromo-header_remaining_plural').addClass('hidden');
                        } else {
                            $('.layer-complete-your-promo-modal').find('.js-completeYourPromo-header_remaining_completed').addClass('hidden');
                            $('.layer-complete-your-promo-modal').find('.js-completeYourPromo-header_remaining_single').addClass('hidden');
                            $('.layer-complete-your-promo-modal').find('.js-completeYourPromo-header_remaining_plural').removeClass('hidden');
                        }

                        // Add new product tiles
                        if ($productItem.find('.js-added-text').hasClass('hide')) {
                            $productItemHidden.find('.js-added-text').removeClass('hide');
                            $productItem.find('.js-added-text').removeClass('hide');
                            $productItem.find('.js-added-quantity').removeClass('hidden');
                            $productItem.find('.js-added-size').removeClass('hidden');
                            $productItem.find('.product').addClass('active');
                            $productItem.find('.js-added-size-value').html($(modal.modalBox).find('.js-selected-size').html());
                            $productItem.find('.js-added-quantity-value').html(1);
                            $productItem.find('#showModalAdd').data('selected-size', $(modal.modalBox).find('.js-selected-size').html());
                            for (let i = 1; i < quantity; i++) {
                                let $productItemcopy = $productItem.clone();
                                $productItem.after($productItemcopy);
                            }
                        } else {
                            for (let i = 0; i < quantity; i++) {
                                let $productItemcopy = $productItem.clone();
                                $productItemcopy.find('.js-added-size-value').html($(modal.modalBox).find('.js-selected-size').html());
                                $productItem.after($productItemcopy);
                            }
                        }
                    });
                    // Initially these buttons should be disabled
                    $(modal.modalBox).find('.quantity-circle[data-action="decrease"]').addClass('disabled');
                    if (!$(modal.modalBox).find('.sizes-container input[type="radio"]').is(':checked')) {
                        $(modal.modalBox).find('.js-completePromotionModal-footer_confirm').addClass('disabled');
                    } else if ($(modal.modalBox).find('.sizes-container input[type="radio"]').data('one-size')) {
                        $(modal.modalBox).find('[data-attr="size"] input').trigger('change');
                    }

                    let $productItemAdd = $('.layer-complete-your-promo-modal').find('a[data-pid="' + $(modal.modalBox).find('.add-to-cart-global').data('pid') + '"]').closest('.js-cross-product').first().find('#showModalAdd');
                    if ($productItemAdd.data('selected-size') !== undefined) {
                        $(modal.modalBox).find('#' + $productItemAdd.data('selected-size')).trigger('click');
                    }
                    const pid = $(modal.modalBox).find('.js-product-quickview--tezenis').data('pid');
                    $('body').trigger('product:triggerProductDetails', pid);
                },
                error: () => {
                    $.spinner().stop();
                }
            });
        });
    }
}

const minicart = new Minicart();
export default minicart;
